import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { ImageSliderComponent } from './components/image-slider/image-slider.component';
import { ContactModalComponent } from './components/contact-modal/contact-modal.component';
import { ScrollAnimateDirective } from './directives/scroll-animate.directive';

@NgModule({
  declarations: [HeaderComponent, FooterComponent, ImageSliderComponent, ContactModalComponent, ScrollAnimateDirective],
  imports: [CommonModule, RouterModule, ReactiveFormsModule, FormsModule],
  exports: [HeaderComponent, FooterComponent, ImageSliderComponent, ContactModalComponent, ScrollAnimateDirective, ReactiveFormsModule, FormsModule]
})
export class SharedModule {}
